import type { BooleanFlag, GeneralID } from './baseTypes';
import type { LibType } from './libTypes';

export enum PanoTaskType {
  single = 'single',
  group = 'group',
}

export enum TaskAction {
  replace = 0,
  new = 1,
}

export type PanoSuffix = 'f' | 'b' | 'l' | 'r' | 'u' | 'd' | 'all';

export interface PanoTaskFile {
  md5: string;
  file: File;
  suffix: PanoSuffix;
}

interface PanoTaskCommon {
  exif: string;
  gps: string;
  height: number;
  id: string;
  name: string;
  size: number;
  src: string;
  type: PanoTaskType;
  width: number;
}

export interface PanoCheckResult extends PanoTaskCommon {
  file: File;
  md5: string;
  suffix: PanoSuffix;
}

export interface PanoCollectionItem extends PanoTaskCommon {
  files: PanoTaskFile[];
}

export interface TaskRequestItem {
  action: TaskAction;
  albumId: number;
  exif: string;
  fileId: string;
  gps: string;
  name: string;
  size: number;
  watermarked: BooleanFlag;
  watermarkUrl?: string;
}

export interface TaskRespItem {
  accessKeyId: string;
  accessKeySecret: string;
  bucketName: string;
  endpointO: string;
  expired: BooleanFlag;
  fileId: string;
  panoId: number;
  path: string;
  region: string;
  securityToken: string;
  taskId: number;
}

export interface MatrixCheckResult {
  id: string;
  file: File;
  name: string;
  size: number;
  md5: string;
  gps: string;
  exif: string;
}

export interface MTaskRespItem
  extends Omit<TaskRespItem, 'expired' | 'panoId'> {
  materialId: number;
}

export interface PVTaskRequestData {
  fileId: string;
  name: string;
  size: number;
  duration: number;
  width: number;
  height: number;
  albumId: number;
}

export interface PVTaskRespData extends Omit<MTaskRespItem, 'path'> {
  key: string;
}

// 0:全景视频;1:全景图片;2:矩阵图片;3:普通图片;4:普通视频;5:漫游作品
export enum MaterialType {
  panoVideo = 0,
  pano = 1,
  matrix = 2,
  image = 3,
  video = 4,
  tour = 5,
}

export type TaskLibType = LibType.pano | LibType.matrix | LibType.panoVideo;

export type TaskItem = {
  id: GeneralID;
  libId?: number;
  libType: TaskLibType;
  name: string;
  thumbUrl?: string;
  isError?: boolean;
};
